import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Store } from '@ngrx/store';
import { AmplifyInternalService } from '@twaice-fe/frontend/shared/services';
import { selectors } from '@twaice-fe/frontend/shared/store';
import { buildTimezoneOptions, getTimezoneOffsetFromUtc } from '@twaice-fe/frontend/shared/utilities';
import { CustomUserTimezone } from '@twaice-fe/shared/models';
import { NzAlertModule } from 'ng-zorro-antd/alert';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzSelectModule } from 'ng-zorro-antd/select';

const { authSelectors } = selectors;

@Component({
  selector: 'twaice-fe-timezone',
  imports: [CommonModule, FormsModule, NzAlertModule, NzSelectModule, NzButtonModule],
  templateUrl: './timezone.component.html',
  styleUrls: ['./timezone.component.scss'],
})
export class TimezoneComponent {
  readonly CustomUserTimezone = CustomUserTimezone;
  selectedTimeZone: string;
  loading = false;

  flatTimezones: { name: string; offset?: string; isGroupDivider: boolean; value: CustomUserTimezone | string }[] = [
    {
      name: 'Storage time',
      isGroupDivider: false,
      offset: 'Timezone of the respective storage',
      value: CustomUserTimezone.STORAGE_TIME,
    },
    {
      name: 'Browser time',
      isGroupDivider: false,
      offset: `${Intl.DateTimeFormat().resolvedOptions().timeZone}, ${getTimezoneOffsetFromUtc(
        Intl.DateTimeFormat().resolvedOptions().timeZone
      )}`,
      value: CustomUserTimezone.BROWSER_TIME,
    },
    { name: 'Coordinated Universal Time', isGroupDivider: false, offset: 'UTC', value: CustomUserTimezone.UTC },
    ...buildTimezoneOptions(),
  ];

  constructor(
    private amplifyInternalService: AmplifyInternalService,
    private store: Store
  ) {
    this.store.select(authSelectors.getUserTimezone).subscribe((timezone) => {
      this.selectedTimeZone = timezone;
    });
  }

  async save() {
    this.loading = true;
    await this.amplifyInternalService.updateUserAttribute({ 'custom:timezone': this.selectedTimeZone });
    window.location.reload();
  }
}
